module.exports = __webpack_public_path__ + "img/9788983947192.656451de.jpg";